import {
  fetchBasedCall,
  IHttpCall,
  IHttpRequest,
  IHttpResponse,
} from '@hc-frontend/core-utils-net';

import { SendBlueshiftEventRequest } from './send-blueshift-event.types';

type SendBlueshiftEventOptions = Partial<Omit<IHttpRequest<void>, 'body'>> & {
  httpCall?: IHttpCall;
};

export function sendBlueshiftEvent(
  baseUrl: string,
  payload: SendBlueshiftEventRequest,
  options?: SendBlueshiftEventOptions,
): Promise<IHttpResponse<void>> {
  const { httpCall = fetchBasedCall, headers, ...restOptions } = options ?? {};

  const request: IHttpRequest<SendBlueshiftEventRequest> = {
    url: `${baseUrl}/api/v1/event`,
    method: 'POST',
    body: payload,
    headers,
    schemas: {
      request: SendBlueshiftEventRequest,
    },
    ...restOptions,
  };
  return httpCall(request);
}
